import { createContext } from 'react';

export const UndoContext = createContext<{
  undo?: () => void;
  redo?: () => void;
}>({
  undo: undefined,
  redo: undefined,
});
